module.exports = __webpack_public_path__ + "assets/files/Terms_conditions.a83c8dcb.pdf";